<template>
	<div class="home_container" :class="[isNewSkin ? 'home_container_bg_new' : 'home_container_bg']" v-show="outerIsShow">
		<div v-if="show">
			<div class="header_container">
				<div class="logo">
					<img src="../assets/image/logo.png" alt />
				</div>
				<div class="centerBtn">
					<div class="RuleBtn" @click="activityRule()">
            <!-- 旧按钮路径 -->
						<img v-if="!isNewSkin" src="../assets/image/button/activityRule.png" alt />
            <!-- 新按钮路径 -->
            <img v-else src="../assets/image/gameImages/button/activityRule.png" alt />
					</div>
				</div>
				<div class="rightBtn">
					<div class="myGiftBtn" @click="myGiftBtn()">
            <!-- 旧按钮路径 -->
						<img v-if="!isNewSkin" src="../assets/image/button/myGift.png" alt />
             <!-- 新按钮路径 -->
             <img v-else src="../assets/image/gameImages/button/myGift.png" alt />
					</div>
				</div>
				<div class="rightIcon"></div>
			</div>
			<div class="content_container">
				<div class="content_box" :class="[isNewSkin ? 'content_box_bg_new' : 'content_box_bg']">
					<div class="indexLine">
						<!-- <img src="../assets/image/indexLine.png" alt /> -->
						<van-row class="m_b">
							<van-col span="24" class="c_w m_b5 t_ac fw f_18">{{ this.userInfo ? this.userInfo.actName : '- -' }}</van-col>
						</van-row>
						<van-row class="m_b">
							<van-col span="24" class="c_w m_b5 t_ac fw f_18">{{ this.userInfo ? this.userInfo.describ : '- -' }}</van-col>
						</van-row>
						<van-row class="m_b5">
							<van-col span="24" class="c_w t_ac">
								<div class="onlyLine02">
									<img src="../assets/image/onlyLine.png" alt />
								</div>
								<!-- <div class="onlyLine">
            <img src="../assets/image/onlyLine.png" alt />
                </div>-->
							</van-col>
						</van-row>
					</div>
					<div class="input_box">
						<van-row>
							<van-col span="14" class="c_w m_b5 f_14">手机号码：</van-col>
						</van-row>
						<van-row>
							<van-col span="24" class="c_w m_b5">
								<div class="showInfoDiv">{{ this.userInfo ? this.userInfo.phone : '- -' }}</div>
							</van-col>
						</van-row>
						<van-row class="m_b10">
							<van-col span="10"></van-col>
						</van-row>
						<van-row>
							<van-col span="14" class="m_b5 c_w f_14">可抽奖次数：</van-col>
						</van-row>
						<van-row class="m_b35">
							<van-col span="24" class="m_b5 c_w">
								<div class="showInfoDiv">{{ this.userInfo ? this.userInfo.luckyMaxTimes - this.userInfo.luckyCurrentTimes : 0 }}</div>
							</van-col>
						</van-row>
						<van-row>
							<van-col span="24">
								<div @click="confirmBtn()" class="bottomConfirmBtn" :class="[isNewSkin ? 'bottomConfirmBtn_bg_new' : 'bottomConfirmBtn_bg']">{{ this.userInfo ? this.userInfo.buttonName : '- -' }}</div>
							</van-col>
						</van-row>
					</div>
				</div>
			</div>
		</div>

		<div class="videoBox" v-show="!show">
			<video
				id="media"
				v-if="!time"
				src="../assets/video/video02.mp4"
				style="object-fit: fill;"
				width="100%"
				x5-video-player-type="h5"
				x5-video-player-fullscreen="true"
				webkit-playsinline="true"
			></video>
		</div>
	</div>
</template>

<script>
import { Toast, Dialog } from 'vant';
import URL from '@/utils/url';
export default {
	data() {
		return {
			time: false,
			state: false,
			show: true,
			// 没有可以参加的活动,或活动已过期的特殊处理:
			pastDue: '',
			outerIsShow: false, //避免落地还能看到抽奖页面
      isNewSkin: false, // 是否新皮肤
		};
	},

	computed: {
		userInfo02: function() {
			return this.$store.getters.getInfo02;
		},
		userInfo: function() {
			return this.$store.getters.getInfo;
		},
	},

	watch: {
		state: function(newval, oldval) {
			if (newval) {
				this.$router.push({ name: 'giftDraw' });
			}
		},
	},

	methods: {
		// 通过地址栏信息，获取用户信息：
		async getUserInfo() {
			try {
				if (window.location.href.includes('id=')) return false;
				if (!this.userInfo02) return Toast('获取用户信息失败，暂无法抽奖');
				const toastLoading = Toast.loading({
					message: '正在加载',
					forbidClick: true,
					duration: 0,
				});
				let params = {
					luckActId: this.userInfo02.luckActId,
					param: this.userInfo02.param,
				};
				let { data: result } = await this.$get('getInformationByParam', params);
				if (result.code !== 200) {
					toastLoading.clear();
					this.$store.commit('LOGOUT');
					this.$store.commit('LOGOUT02');
					if (result.code === 500 && result.errMsg === '没有可以参加的活动,或活动已过期') {
						this.pastDue = result.errMsg;
						return this.$router.push({ name: 'noActive' });
					} else {
						return Toast('抱歉，不满足抽奖资格');
					}
				}
				toastLoading.clear();
				this.$store.commit('LONIN_SET', result.data);
				// 2020 09 30 zzg add start 新增逻辑:
				if (result.data.luckActId && result.data.encryption) {
					let baseUrlObj = {
						luckActId: result.data.luckActId,
						param: result.data.encryption,
					};
					// 设置用户参数：
					this.$store.commit('LONIN_SET02', baseUrlObj);
				}
				// 2020 09 30 zzg add end
				// 0323add start:
				if (result.data.phone == 10000000000) {
					Dialog.alert({
						message: '返回后请下拉订单列表刷新后重新点击抽奖！',
					}).then(() => {
						top.window.location.href = this.$linkURL + 'order';
					});
				}
				// 0323add end:x
			} catch (err) {
				console.log(err);
			}
		},

		activityRule() {
			this.$Sensors.track('LuckydrawHomePageClick', {
				button_name: '活动规则',
				cellphone: this.userInfo ? this.userInfo.phone : '',
				available: this.userInfo ? this.userInfo.luckyMaxTimes - this.userInfo.luckyCurrentTimes : '',
			});


			this.$router.push({ name: 'activityRule' });
		},

		myGiftBtn() {
			this.$Sensors.track('LuckydrawHomePageClick', {
				button_name: '我的奖品',
				cellphone: this.userInfo ? this.userInfo.phone : '',
				available: this.userInfo ? this.userInfo.luckyMaxTimes - this.userInfo.luckyCurrentTimes : '',
			});


			if (!this.userInfo) return Toast('无法获取用户信息，暂无法查看');
			this.$router.push({ name: 'myGiftAll' });
		},

		confirmBtn() {
			if (!this.userInfo) {
				let res = this.pastDue ? this.pastDue : `无法获取用户信息，暂无法抽奖`;
				return Toast(res);
			} else {
				this.$Sensors.track('LuckydrawHomePageClick', {
					button_name: '抽奖赢好礼',
					cellphone: this.userInfo ? this.userInfo.phone : '',
					available: this.userInfo ? this.userInfo.luckyMaxTimes - this.userInfo.luckyCurrentTimes : '',
				});


				if (this.userInfo.luckyMaxTimes - this.userInfo.luckyCurrentTimes === 0) {
					return Toast('抽奖次数已用完');
				}
			}
			// video start：
			this.show = false;
			document.getElementById('media').play();
		},
	},

	created() {
		this.$Sensors.track('LuckydrawHomePageView');

		this.state = false;
		let $url = URL;
		// 针对落地营销做判断：
		// 2020 06 12 add zzg start:
		if (window.location.href.includes('id=') && !window.location.href.includes('utm_source')) {
			let newResult = $url.toObject(window.location.href, true);
			this.$router.push({ name: 'groundMarketingHome', query: { id: newResult.id } });
		} else if (window.location.href.includes('id=') && window.location.href.includes('utm_source')) {
			let newResult = $url.toObject(window.location.href, true);
			this.$router.push({ name: 'groundMarketingHome', query: { id: newResult.id, utm_source: newResult.utm_source } });
		}
		// 2020 06 12 add zzg end

		// 避免落地能看到抽奖：
		setTimeout(() => {
			this.outerIsShow = true; //抽奖显示
		}, 500);

		// 通过地址栏拿到信息：
		this.$store.commit('LOGOUT');
		this.$store.commit('LOGOUT02');
		let baseUrlStr = '';
		let baseUrlObj = {};
		if (window.location.href.includes('luckActId') && window.location.href.includes('param')) {
			baseUrlStr = window.location.href;
		} else {
			baseUrlStr = '';
		}
		const query = $url.toObject(baseUrlStr, true);
		baseUrlObj = query;
		if (JSON.stringify(baseUrlObj) === '{}') return;
		// 设置用户参数：
		this.$store.commit('LONIN_SET02', baseUrlObj);

    this.isNewSkin = sessionStorage.getItem('isNewSkin') ? true : false;
	},

	mounted() {
		document.title = '抽奖';
		setTimeout(() => {
			this.getUserInfo();
		}, 300);
		// 已经开始抽奖了：监听视频是否播放完毕
		if (!this.state) {
			document.getElementById('media').loop = false; // 不设置视频循环播放
			document.getElementById('media').addEventListener(
				'ended',
				() => {
					//该视频播放是否已结束
					this.time = !this.time;
					this.state = true;
				},
				false
			);
		}
	},
};
</script>

<style lang="scss">
.van-dialog {
	border-radius: 5px;
}
.van-dialog__confirm,
.van-dialog__confirm:active {
	color: #fff;
	background-color: #0076b3;
}
.van-dialog__message {
	font-weight: bold;
	padding-top: 30px;
	padding-bottom: 30px;
}
</style>

<style lang="scss" scoped>
/deep/.van-cell {
	width: 100%;
	height: 100%;
	background-color: #dcf6ff;
	line-height: 35px;
	padding-top: 0px;
	padding-bottom: 0px;
}
.home_container {
	width: 100%;
	height: 100%;
	background-size: 100% 100%;
	border-top: 1px solid transparent;
	.header_container {
		width: 100%;
		height: 60px;
		display: flex;
		margin-top: 20px;
		.logo {
			flex: 3;
			padding-left: 15px;
			img {
				width: 100%;
			}
		}
		.centerBtn {
			flex: 2;
			padding-left: 20px;
			.RuleBtn {
				width: 90%;
				height: 100%;
				img {
					width: 100%;
				}
			}
		}
		.rightBtn {
			flex: 2;
			padding-left: 10px;
			.myGiftBtn {
				width: 90%;
				height: 100%;
				img {
					width: 100%;
				}
			}
		}
		.rightIcon {
			width: 20px;
			padding-left: 10px;
			padding-top: 5px;
			img {
				width: 50%;
			}
		}
	}
	.content_container {
		margin-top: 30px;
		width: 100%;
		height: 500px;
		.content_box {
			width: 370px;
			height: 100%;
			margin: 0 auto;
      // 旧背景路径
			// background-image: url(../assets/image/blueBgc02.png);
      // 新背景路径
      // background-image: url(../assets/image/gameImages/blueBgc02.png);
			background-size: cover;
			padding-top: 90px;
			.indexLine {
				width: 55%;
				height: 90px;
				margin: 0 auto;
				img {
					width: 100%;
				}
			}
			.input_box {
				width: 55%;
				height: 30px;
				margin: 0 auto;
				.phoneInput {
					width: 100%;
					height: 35px;
					background-image: url(../assets/image/input/phoneInput.png);
					background-size: 100% 100%;
				}
				.showInfoDiv {
					width: 100%;
					height: 35px;
					line-height: 35px;
					background-color: rgba(0, 0, 0, 0.3);
					border-radius: 5px;
					color: #fff;
					padding-left: 15px;
				}
				.phoneCodeInput {
					width: 100%;
					height: 35px;
					background-image: url(../assets/image/input/phoneCodeInput.png);
					background-size: 100% 100%;
				}
				.phoneCodeBtn {
					width: 100%;
					height: 35px;
					background-image: url(../assets/image/input/phoneCodeBtn.png);
					background-size: 100% 100%;
					text-align: center;
					line-height: 35px;
				}
				.innerInput {
					width: 90%;
					height: 100%;
					margin: 0 auto;
				}
			}
		}
    .content_box_bg {
      // 旧背景路径
      background-image: url(../assets/image/blueBgc02.png);
    }
    .content_box_bg_new {
      // 新背景路径
      background-image: url(../assets/image/gameImages/blueBgc02.png);  
    }
	}
}

.home_container_bg {
  // 旧背景路径
	background-image: url('../assets/image/bgc01.png');
}

.home_container_bg_new {
  // 新背景路径
  background-image: url('../assets/image/gameImages/bgc01.png');
}

@keyframes videoBoxChange {
	from {
		background-color: #272368;
	}
	20% {
		background-color: #0b081a;
	}
	40% {
		background-color: #272368;
	}
	60% {
		background-color: #0b081a;
	}
	80% {
		background-color: #272368;
	}
	to {
		background-color: #6b7a95;
	}
}
.videoBox {
	width: 100%;
	height: 100%;
	animation: videoBoxChange 3s linear 0s infinite;
	#media {
		position: absolute;
		top: 50%;
		left: 0px;
		transform: translateY(-50%);
	}
}
.onlyLine {
	width: 80%;
	height: 1px;
	margin: 0 auto;
	background-color: rgba(255, 255, 255, 0.5);
	// img {
	//   width: 60%;
	//   margin-bottom: 7px;
	// }
}
.onlyLine02 {
	width: 100%;
	height: 20px;
	margin: 0 auto;
	// background-color: #000;
	img {
		width: 60%;
		// margin-bottom: 7px;
	}
}
.bottomConfirmBtn {
	width: 80%;
	height: 50px;
	margin: 0 auto;
	background-size: 100% 100%;
	color: #fff;
	font-weight: bold;
	text-align: center;
	line-height: 50px;
	font-size: 14px;
}

.bottomConfirmBtn_bg {
  // 旧按钮路径
	background-image: url(../assets/image/onlyBtn.png);
}

.bottomConfirmBtn_bg_new {
  // 新按钮路径
  background-image: url(../assets/image/gameImages/onlyBtn.png);
}
</style>
